/**
 * @description
 *
 * Transition функция - ускоряется до половины, потом замедляется.
 *
 * @param {number} time - текущее время
 * @param {number} start - позиция начала скролла
 * @param {number} change - разница между координатой начала скроллинга и координатой окончания скроллинга
 * @param {number} duration - продолжительность анимации
 *
 * @returns {number | string} -
 */

function easeInOutQuad(time: number, start: number, change: number, duration: number) {
  let newTime = time / (duration / 2)

  if (newTime < 1) {
    return (change / 2) * newTime * newTime + start
  }

  newTime -= 1

  return (-change / 2) * (newTime * (newTime - 2) - 1) + start
}

/** Инкремент отменяет незавершённую анимацию предыдущего smoothScrollTo */
let scrollGeneration = 0

/**
 * @description
 *
 * Скроллит страницу к указанному значению от верхнего края документа или родителя (element).
 * Новый вызов отменяет предыдущую незавершённую анимацию.
 *
 * @param {number} to - до какой позиции производить скролл
 * @param {object} options -
 * @param {number} options.offset - отступ сверху
 * @param {number} options.duration - продолжительность анимации
 * @param {string=} options.dataAttr - название атрибута, который будет вешаться на body во время скролла (может понадобиться для корректной работы автотестов)
 * @param { HTMLElement } element - элемент, относительно которого производится скролл. По умолчанию относительно документа
 */

function smoothScrollTo(
  to = 0,
  options: { offset?: number, duration?: number, dataAttr?: string } = {},
  element: Element | undefined = undefined,
) {
  if (typeof document === 'undefined') {
    return
  }

  scrollGeneration += 1

  const generation = scrollGeneration
  const {
    offset = 0,
    duration = 600,
    dataAttr = '',
  } = options
  const toWithOffset = to + offset
  const node = !element ? document.scrollingElement || document.documentElement : element
  const start = node.scrollTop
  const change = toWithOffset - start
  const startDate = new Date().getTime()

  if (dataAttr) {
    document.body.setAttribute(dataAttr, '')
  }

  function cleanup() {
    if (dataAttr) {
      document.body.removeAttribute(dataAttr)
    }
  }

  function animateScroll() {
    if (generation !== scrollGeneration) {
      cleanup()

      return
    }

    const currentDate = new Date().getTime()
    const currentTime = currentDate - startDate

    node.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration).toString(), 10)

    if (currentTime < duration) {
      requestAnimationFrame(animateScroll)

      return
    }

    node.scrollTop = toWithOffset
    cleanup()
  }

  animateScroll()
}

export default smoothScrollTo
